import React from 'react';
import { useDispatch } from 'react-redux';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import { useAppSelector } from 'src/store/store';
import {
  setSearchField,
  setIsRestrictionFormTableFilterSheetOpen,
} from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import ToggleFilterButton from 'src/components/shared/toggleFilterButton/toggleFilterButton';

const TopOptions = () => {
  const dispatch = useDispatch();
  const { searchField } = useAppSelector((state) => state.regionTasksConfigPage);
  return (
    <Row width="grid-4" spacingInset="400 none" alignmentHorizontal="justify">
      <Row width="grid-4">
        <SearchField
          value={searchField}
          onChange={(newSearchField) => dispatch(setSearchField(newSearchField))}
          placeholder="Search for..."
          onSubmit={() => {}}
        />
        <ToggleFilterButton
          data-testid="restriction-form__filter-sheet-btn"
          tooltipTitle="Open Work/Requirement Table Filter"
          onClick={() => dispatch(setIsRestrictionFormTableFilterSheetOpen(true))}
        />
      </Row>
    </Row>
  );
};

export default TopOptions;
